import { store } from "../store";
import { setAuthToken, setIsLoggedIn } from "../store/slices/authState";
import { setUserData } from "../store/slices/userState";
import { clearToken, clearUserId, saveUserType } from "./asyncStoreManager";
import { string } from "./string";
import asyncStorageKeys from "./asyncStorageKeys";
import { setCartCount, setWhishlistCount } from "../store/slices/countState";
import { BASE_URL } from "./configConstants";
import { setWhishlist } from "../store/slices/whishlistState";
import NavigationService from "../utils/navigationService";
// import { appApiHandler } from "../api/appApiHandler";

export function emailValidator(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function passwordValidator(password) {
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  return passwordRegex.test(password);
}

export const handleNumberInputWithoutDecimal = (text) => {
  let sanitizedText = text?.replace(/[^0-9]/g, "");
  return sanitizedText;
};

export function handleBlanckSpaceInput(text) {
  let sanitizedText = text?.replace(/\s/g, "");
  return sanitizedText;
}

export function handleUpperCaseNoSpace(text) {
  let sanitizedText = text?.replace(/\s/g, "").toUpperCase();
  return sanitizedText;
}

export function getInitials(name) {
  if (!name) return "";
  return name.trim()[0].toUpperCase();
}

export const clearStates = async () => {
  try {
    // const fcmToken = NotificationService.getFCMToken();
    // const reqData = {
    //   token:fcmToken,
    //   user_id:store.getState().userState.userData?._id,
    // }
    // const response = await appApiHandler.logOut(reqData);
    await clearToken();
    await clearUserId();
    await saveUserType("retailer");
    store.dispatch(setUserData(null));
    store.dispatch(setIsLoggedIn(false));
    store.dispatch(setAuthToken(""));
    store.dispatch(setCartCount(0));
    store.dispatch(setWhishlistCount(0));
    store.dispatch(setWhishlist([]));

    // Navigate to login using navigation service
    // NavigationService.resetToLogin();

    return true;
  } catch (error) {
    console.error("Error clearing states:", error);
    return false;
  }
};

export const getErrorMessage = (msg) => {
  const messsage =
    typeof msg === "string" ? msg : string.error.failed_due_to_internal_error;
  return messsage;
};

export const getPrice = (item) => {
  try {
    const userType =
      window.localStorage.getItem(asyncStorageKeys.USER_TYPE) || null;
    const value =
      userType === "wholeseller"
        ? parseInt(item?.wholesale_price)
        : parseInt(item?.retail_price);
    return Number.isNaN(value) ? 0 : value;
  } catch (e) {
    const fallback = parseInt(item?.retail_price);
    return Number.isNaN(fallback) ? 0 : fallback;
  }
};

export const getImageUrl = (imagePath) => {
  if (!imagePath) return "";
  return `${BASE_URL}${imagePath}?t=${Date.now()}`;
};

const compressionCache = new Map();
const compressionQueue = new Set();

const compressImage = async (
  imageUrl,
  quality = 0.95,
  maxWidth = null,
  maxHeight = null,
  cacheKey = null
) => {
  const key = cacheKey || imageUrl;

  if (compressionCache.has(key)) {
    return compressionCache.get(key);
  }

  if (compressionQueue.has(key)) {
    return new Promise((resolve) => {
      const checkCache = () => {
        if (compressionCache.has(key)) {
          resolve(compressionCache.get(key));
        } else {
          setTimeout(checkCache, 100);
        }
      };
      checkCache();
    });
  }

  compressionQueue.add(key);

  try {
    let response;
    try {
      response = await fetch(imageUrl, {
        mode: "cors",
        credentials: "omit",
      });
    } catch {
      response = await fetch(imageUrl);
    }

    if (!response.ok) {
      throw new Error(`Failed to fetch image: ${response.status}`);
    }

    const imageBlob = await response.blob();
    const imageObjectUrl = URL.createObjectURL(imageBlob);

    const img = await new Promise((resolve, reject) => {
      const image = new Image();
      image.crossOrigin = "anonymous";
      image.onload = () => {
        URL.revokeObjectURL(imageObjectUrl);
        resolve(image);
      };
      image.onerror = reject;
      image.src = imageObjectUrl;
    });

    let width = img.width;
    let height = img.height;

    if (maxWidth && width > maxWidth) {
      height = (height * maxWidth) / width;
      width = maxWidth;
    }

    if (maxHeight && height > maxHeight) {
      width = (width * maxHeight) / height;
      height = maxHeight;
    }

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, width, height);

    // ✅ Convert to WEBP
    const webpBlob = await new Promise((resolve) => {
      canvas.toBlob(
        (blob) => resolve(blob),
        "image/webp",
        quality
      );
    });

    // 🛟 Fallback (very rare)
    if (!webpBlob) {
      console.warn("WebP failed, falling back to original");
      compressionCache.set(key, imageUrl);
      return imageUrl;
    }

    const webpUrl = URL.createObjectURL(webpBlob);
    compressionCache.set(key, webpUrl);

    return webpUrl;
  } catch (error) {
    console.error("WebP conversion failed:", error);
    compressionCache.set(key, imageUrl);
    return imageUrl;
  } finally {
    compressionQueue.delete(key);
  }
};


export const getOptimizedUrl = (path, height = null, width = null, compressionQuality = 0.95) => {
  if (!path) return "";

  // const cacheKey = path;
  const imageUrl = `${BASE_URL}${path}`;
  // const imageUrl = `${BASE_URL}${path}?t=${Date.now()}`;

  // if (compressionCache.has(cacheKey)) {
  //   return compressionCache.get(cacheKey);
  // }

  // compressImage(imageUrl, compressionQuality, width || null, height || null, cacheKey)
  //   .then((compressedUrl) => {
  //     compressionCache.set(cacheKey, compressedUrl);

  //     const images = document.querySelectorAll("img");
  //     images.forEach((img) => {
  //       if (img.src && img.src.includes(path) && !img.src.startsWith("blob:")) {
  //         img.src = compressedUrl;
  //       }
  //     });
  //   })
  //   .catch(() => { });

  return imageUrl;
};

// export const getOptimizedUrl = (path, height, width) => {
//   const queryParams = [`path=${encodeURIComponent(path)}`];
//   if (width !== undefined && width !== null && width !== "") {
//     queryParams.push(`width=${width}`);
//   }
//   if (height !== undefined && height !== null && height !== "") {
//     queryParams.push(`height=${height}`);
//   }
//   const optimizedUrl = `${BASE_URL}optimized-image?${queryParams.join("&")}`;
//   return `${optimizedUrl}?t=${Date.now()}`;
// };